import type { TestimonialVariant } from "../cms/testimonials";

export function testimonialVariant(value: unknown): TestimonialVariant {
  return value === "split" ||
    value === "image-cards" ||
    value === "quote-carousel"
    ? value
    : "standard";
}

export function testimonialRating(value: unknown): number {
  return typeof value === "number" &&
    Number.isInteger(value) &&
    value >= 1 &&
    value <= 5
    ? value
    : 0;
}

export function testimonialLink(value: unknown): string | undefined {
  if (typeof value !== "string") return undefined;
  const href = value.trim();
  if (
    /[\s\\]/.test(href) ||
    [...href].some(
      (char) => char.charCodeAt(0) < 32 || char.charCodeAt(0) === 127,
    )
  )
    return undefined;
  if (/^\/(?!\/)|^#[\w-]+$|^(?:mailto|tel):[^:]+$/i.test(href)) return href;
  // The CMS page picker can return a slug without a leading slash.
  if (
    /^[\p{L}\p{N}_-]+(?:[/?#]|$)/u.test(href) &&
    !href.split(/[?#]/)[0].includes(":")
  )
    return `/${href}`;
  try {
    const url = new URL(href);
    if (
      ["https:", "http:"].includes(url.protocol) &&
      !url.username &&
      !url.password
    )
      return href;
  } catch {
    /* Invalid links are omitted, without changing saved content. */
  }
  return undefined;
}

export function testimonialInterval(value: unknown): number {
  return typeof value === "number" && Number.isFinite(value)
    ? Math.min(60000, Math.max(3000, value))
    : 8000;
}
